import { z } from "zod";

import type { ActionProposalArtifact } from "~/shared/ai/assistant-action-artifact";
import type { ReportArtifactCommit } from "~/utils/types/assistant-report-artifact";

export const ConversationIdSchema = z.string().min(1).max(200);
export type ConversationId = z.infer<typeof ConversationIdSchema>;

export const ProviderContinuationRecoverySchema = z
  .object({
    conversationId: ConversationIdSchema,
    sourceTurnId: z.string().uuid(),
    proposalId: z.string().uuid().optional(),
  })
  .strict();
export type ProviderContinuationRecovery = z.infer<typeof ProviderContinuationRecoverySchema>;

export const ConversationCompletionDispositionSchema = z.enum(["recovery_only"]);
export type ConversationCompletionDisposition = z.infer<typeof ConversationCompletionDispositionSchema>;

export const ToolActivityOutcomeSchema = z.enum(["succeeded", "needs_adjustment", "blocked", "failed", "reused"]);
export type ToolActivityOutcome = z.infer<typeof ToolActivityOutcomeSchema>;

export const AgentEntityReferenceSchema = z
  .object({
    kind: z.enum([
      "note",
      "customer",
      "contact",
      "supplier",
      "product",
      "sales_order",
      "purchase_order",
      "invoice",
      "bill",
      "credit_note",
      "supplier_credit",
    ]),
    id: z.string().min(1),
    label: z.string().min(1),
    href: z.string().min(1).optional(),
  })
  .strict();
export type AgentEntityReference = z.infer<typeof AgentEntityReferenceSchema>;

/**
 * Client-normalized terminal state. Providers keep the existing `done.threadId`
 * wire field; the shared hook exposes its provider-neutral conversation meaning.
 */
export interface ConversationCompletion {
  conversationId: ConversationId;
  turnId?: string;
  completionDisposition?: ConversationCompletionDisposition;
  reportArtifactCommit?: ReportArtifactCommit;
  actionProposalCommit?: ActionProposalArtifact;
}
